<script setup lang="ts">
  import { type IconValues } from '@gat-ship/icons'
  import { Spinner } from '@gat-ship/vue-components'
  const props = defineProps<{
    modelValue: boolean | undefined
    label: string
    description: string
    icon: IconValues
    descriptionTestId?: string
  }>()

  const emits = defineEmits<{
    (e: 'update:modelValue', value: boolean | undefined): void
    (e: 'click', value: boolean | undefined): void
  }>()

  const loading = defineModel<boolean>('loading', {
    default: false
  })
</script>

<template>
  <label
    class="bg-background shadow-xs ring-border relative flex cursor-pointer items-center gap-3.5 rounded-sm p-4 pr-16 ring-1 ring-inset"
    @click="emits('click', !modelValue)"
  >
    <div
      class="bg-background shadow-xs ring-border flex size-10 shrink-0 items-center justify-center rounded-full ring-1 ring-inset"
    >
      <spinner v-if="loading" class="size-4" />
      <gat-icon v-else :icon="icon" class="size-4" />
    </div>
    <switch-tiny
      :model-value="modelValue"
      class="absolute right-5 top-5"
      @update:model-value="emits('update:modelValue', $event)"
    />
    <div class="space-y-1">
      <div class="flex items-center gap-1 text-sm font-medium">
        <span>{{ label }}</span>
      </div>
      <div
        role="description"
        :data-testid="descriptionTestId"
        class="text-soft text-xs"
      >
        {{ description }}
      </div>
    </div>
  </label>
</template>
